import { colors } from "constants/theme"

export default function ApCardTreatment(props: { stroke?: string, fill?: string }) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 16.3488V7.65116H7.90698V1H16.3488V7.65116H23V16.3488H16.3488V23H7.90698V16.3488H1Z" fill={props.fill || colors.white} stroke={props.stroke || colors.lightGray} strokeWidth="2" strokeLinejoin="round" />
        </svg>
    )
}
